import { createSlice } from "@reduxjs/toolkit";
import {
    getManualEntryList,
    addManualEntry,
    getDeleteMessageManual,
    deleteManualEntry,
    updateManualEntry,
    getUpdateManualEntry,
} from "./manualEntryAction";

const initialState = {
    manualEntryData: [],
    manualMeta: { totalRecords: 0, totalPages: 0, currentPage: 1, pageSize: 10 },
    status: "idle",
    error: null,
    updateStatus: "idle",
    updateError: null,
    deleteMessage: "",
};

const manualEntrySlice = createSlice({
    name: "manualEntry",
    initialState,

    reducers: {
        clearManualEntryData(state) {
            return initialState;
        },
    },

    extraReducers: (builder) => {
        builder

            // ================= LIST =================
            .addCase(getManualEntryList.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })

            // .addCase(getManualEntryList.fulfilled, (state, action) => {
            //     state.status = "succeeded";

            //     // const responseData = action.payload?.data?.data || [];

            //     // state.manualEntryData = Array.isArray(responseData)
            //     //     ? responseData
            //     //     : [];

            //     state.manualEntryData = action.payload?.data?.data || [];

            //     state.manualMeta = action.payload?.data?.meta || {};

            // })
            .addCase(getManualEntryList.fulfilled, (state, action) => {
                state.status = "succeeded";

                const paged = action.payload?.data?.data || {};

                state.manualEntryData = Array.isArray(paged.data)
                    ? paged.data
                    : [];

                state.manualMeta = {
                    totalRecords: paged.TotalRecords ?? 0,
                    totalPages: paged.TotalPages ?? 0,
                    currentPage: paged.CurrentPage ?? 1,
                    pageSize: paged.PageSize ?? 10,
                };
            })
            // .addCase(getManualEntryList.fulfilled, (state, action) => {
            //     state.status = "succeeded";

            //     state.manualEntryData = Array.isArray(action.payload.data.data)
            //         ? action.payload.data.data
            //         : [];

            //     state.manualMeta = {
            //         totalRecords: action.payload.data.data.length,
            //         totalPages: 1,
            //         currentPage: 1,
            //         pageSize: action.payload.data.data.length,
            //     };
            // })
            .addCase(getManualEntryList.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })

            // ================= CREATE =================
            .addCase(addManualEntry.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })

            .addCase(addManualEntry.fulfilled, (state) => {
                state.status = "succeeded";
            })

            .addCase(addManualEntry.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })

            // ================= UPDATE =================

            .addCase(getUpdateManualEntry.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getUpdateManualEntry.fulfilled, (state) => {
                state.status = "succeeded";
            })
            .addCase(getUpdateManualEntry.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })


            .addCase(updateManualEntry.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(updateManualEntry.fulfilled, (state) => {
                state.status = "succeeded";
            })
            .addCase(updateManualEntry.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            })

            // ================= DELETE =================

            .addCase(getDeleteMessageManual.fulfilled, (state, action) => {
                state.deleteMessage = action.payload.data.message;
            })


            .addCase(deleteManualEntry.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })

            .addCase(deleteManualEntry.fulfilled, (state) => {
                state.status = "succeeded";
            })

            .addCase(deleteManualEntry.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.payload;
            });
    },
});

export const { clearManualEntryData } = manualEntrySlice.actions;

export default manualEntrySlice.reducer;